<finxone-web-frontend-desktop-listing
  [entityData]="entityData"
  [actionOptions]="actionOptions"
  [menuItemsStatus]="menuItemsStatus"
  [dataIn]="dataIn"
  [pageNumber]="pageNumber"
  [entityName]="entityName"
  [totalListCount]="totalListCount"
  [isShowOption]="isShowOption"
  [isShowMoreOption]="isShowMoreOption"
  (pageChange)="onPageChange($event)"
  emptyTableMsg="No Bulk Payment Found"
  (performAction)="performAction($event)"
  [menuPopupCss]="menuPopupCss"
  [threeDotStyles]="threeDotStyles"
  (searchValueText)="searchValue($event)"
></finxone-web-frontend-desktop-listing>
